import React from 'react';
import propTypes from 'prop-types';
export const CheckCircleIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1792 1792"
      //style="enable-background:new 0 0 1792 1792;"
      xmlSpace="preserve"
    >
      {/* <style type="text/css">
	.st0{fill:#FFFFFF;}
</style> */}
      <circle cx="896" cy="896" r="782.9" />
      <path
        className="st0"
        d="M1322.7,592.9c-40.6-40.6-106.3-40.6-146.9,0l-455.7,456L549.4,878.6c-40.6-40.6-106.3-40.6-146.9,0
	c-40.6,40.6-40.6,106.3,0,146.9l233.6,232.4c3.1,4.1,6.5,8.1,10.2,11.8c20.5,20.5,47.5,30.6,74.4,30.4c26.8,0.2,53.7-9.9,74.2-30.4
	c3.8-3.8,7.3-7.9,10.4-12.1l517.4-517.8C1363.3,699.3,1363.3,633.5,1322.7,592.9z"
      />
    </svg>
  );
};
CheckCircleIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
CheckCircleIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
